import { Mode } from './mode.enum';
import { CustomerAgentDetailsModel } from '../shared/models/customer-agent-details-model';
import { CustomerModel } from '../shared/models/customer-model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'hr-customer-edit-agents',
  templateUrl: './customer-edit-agents.component.html',
  styleUrls: ['./customer-edit-agents.component.less'],
  standalone: false,
})
export class CustomerEditAgentsComponent implements OnInit {
  @Output()
  public onUpdate: EventEmitter<CustomerModel> =
    new EventEmitter<CustomerModel>();

  @Input('customer')
  public customerInput: CustomerModel;

  public currentEditingAgent: CustomerAgentDetailsModel;

  public mode: Mode;
  public Mode: any = Mode;

  constructor() {
    this.mode = Mode.List;
  }

  onEditCustomerAgent(customerAgent: CustomerAgentDetailsModel) {
    this.currentEditingAgent = customerAgent;
    this.mode = Mode.Edit;
  }

  onUpdateCustomerAgent() {
    this.mode = Mode.List;
    this.onUpdate.emit(this.customerInput);
  }

  onAddCustomerAgent() {
    this.mode = Mode.Add;
    this.currentEditingAgent = new CustomerAgentDetailsModel();
    this.currentEditingAgent.customerId =
      this.customerInput && this.customerInput.customerId;
  }

  ngOnInit() {}
}
